<div *ngFor="let option of options">
    <input type="radio" [formControl]="control" [value]="option[valueProperty]"
        (change)="onOptionChange(option[valueProperty])">
    <label style="margin-left: 5px;">{{ option[labelProperty] }}</label>
</div>
<div *ngIf="control.invalid && (submitted || control.touched)"
    style="font-size: .875rem; color: #dc3545;position:absolute">
    <div *ngIf="control.errors?.['required']">{{ errorMessage }}</div>
</div>